import { Expose } from 'class-transformer';
import { Model } from './model';

export class StoreRatings extends Model {
  @Expose({ name: '_id' }) id: string;
  @Expose() rating: number;
  @Expose() studentEmail: string;
  @Expose() studentName: string;
  @Expose() comment: string;
}
